import React, {
	useEffect,
	useState,
} from "react";

import {
	getCaseFilterPresentation,
} from "../../data/cases/caseFilterPresentation";

import {
	normalizeCaseFilter,
} from "../../data/cases/caseFilterHelpers";

import styles from "./CaseFilterIdentity.module.css";

/*
 * ============================================================
 * CASE FILTER IDENTITY
 * ============================================================
 *
 * Shared icon / fallback renderer.
 *
 * Used by:
 *
 * Header
 * Slider
 * Future case filter UI
 *
 *
 * filter may be:
 *
 * "fortnite"
 *
 * or:
 *
 * {
 * 		value: "fortnite",
 * 		label: "Fortnite"
 * }
 */
const CaseFilterIdentity = ({
	filter,

	compact = false,
	scope = false,
	slide = false,

	className = "",
}) => {
	const filterValue =
		typeof filter ===
		"object"
			? filter?.value
			: filter;

	const normalizedFilter =
		normalizeCaseFilter(
			filterValue,
		);

	const presentation =
		getCaseFilterPresentation(
			normalizedFilter,
		);

	const [
		imageFailed,
		setImageFailed,
	] = useState(false);

	/*
	 * Important for the compact Header instance:
	 *
	 * the same React component can switch from:
	 *
	 * Fortnite -> Unreal Engine
	 *
	 * without being remounted.
	 */
	useEffect(() => {
		setImageFailed(
			false,
		);
	}, [
		normalizedFilter,
		presentation?.image,
	]);

	if (!presentation) {
		return null;
	}

	const hasImage =
		Boolean(
			presentation.image,
		) &&
		!imageFailed;

	const hasMark =
		Boolean(
			presentation.mark,
		);

	if (
		!hasImage &&
		!hasMark
	) {
		return null;
	}

	return (
		<span
			className={`${styles.icon}${
				hasImage
					? ` ${styles.hasImage}`
					: ""
			}${
				compact
					? ` ${styles.compact}`
					: ""
			}${
				scope
					? ` ${styles.scope}`
					: ""
			}${
				slide
					? ` ${styles.slide}`
					: ""
			}${
				className
					? ` ${className}`
					: ""
			}`}
			aria-hidden="true"
		>
			{hasImage ? (
				<img
					className={
						styles.image
					}
					src={
						presentation.image
					}
					alt=""
					draggable="false"
					onError={() => {
						setImageFailed(
							true,
						);
					}}
				/>
			) : (
				<span
					className={
						styles.fallback
					}
				>
					{
						presentation.mark
					}
				</span>
			)}
		</span>
	);
};

export default React.memo(
	CaseFilterIdentity,
);